"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createOverflowManager", {
    enumerable: true,
    get: function() {
        return _overflowManager.createOverflowManager;
    }
});
const _overflowManager = require("./overflowManager");
